import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import DatePicker from '../../components/forms/formDatePicker';
import ServiceCategorySelect from '../../components/selects/serviceCategorySelect';
import ServiceSelect from '../../components/selects/serviceSelect';

const FilterIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
);
const ChevIcon = () => (
    <svg className="ic chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const SalesFilter = ({ isFiltering, onFilter }) => {

    const { t } = useTranslation();
    const [isShow, setIsShow] = useState(false)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [service, setService] = useState('')
    const [serviceCategory, setServiceCategory] = useState('')
    const queryClient = useQueryClient()

    const activeCount = [dateFrom, dateTo, service, serviceCategory].filter(Boolean).length

    const handleFilter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onFilter([
            dateFrom ? new Date(dateFrom.setHours(0, 0, 0, 0)) : '',
            dateTo ? new Date(dateTo.setHours(23, 59, 59, 999)) : '',
            serviceCategory ?? '',
            service ?? ''
        ])
        setTimeout(() => setIsShow(false), 700)
    }

    const handleReset = () => {
        onFilter(['', '', '', ''])
        setDateFrom('')
        setDateTo('')
        setServiceCategory('')
        setService('')
        queryClient.invalidateQueries(['sales', 'paginated'])
        setTimeout(() => setIsShow(false), 700)
    }

    return (
        <>
            <button type="button" className={`filter-toggle${isShow ? ' on' : ''}`} onClick={() => setIsShow(s => !s)}>
                <FilterIcon /> {t('sales.filters')}
                {activeCount > 0 && <span className="cnt">{activeCount}</span>}
                <ChevIcon />
            </button>

            {isShow && <div className="filter-backdrop" onClick={() => setIsShow(false)} aria-hidden="true" />}

            {isShow && (
                <Form onSubmit={handleFilter} className="filter-panel as-sheet">
                    <div className="filter-sheet-head">
                        <span className="t">{t('sales.filters')}</span>
                        <button type="button" className="x" onClick={() => setIsShow(false)} aria-label={t('common.close')}>
                            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>
                    <div className="filter-grid">
                        <DatePicker className="form-control" label={t('sales.dateFrom')} placeholderText={t('sales.anyStartDate')}
                            selected={dateFrom} onChange={setDateFrom} maxDate={dateTo || undefined} dateFormat="dd.MM.yyyy" portalId="sbr-dp-portal" />
                        <DatePicker className="form-control" label={t('sales.dateTo')} placeholderText={t('sales.anyEndDate')}
                            selected={dateTo} onChange={setDateTo} minDate={dateFrom || undefined} dateFormat="dd.MM.yyyy" portalId="sbr-dp-portal" />
                        <ServiceCategorySelect label={t('sales.serviceCategory')} placeholder={t('sales.allCategories')}
                            value={serviceCategory} onChange={(opt) => setServiceCategory(opt && opt.value)} isClearable menuPortalTarget={document.body} />
                        <ServiceSelect label={t('sales.service')} placeholder={t('sales.allServices')} dateFormat="dd.MM.yyyy"
                            value={service} onChange={(opt) => setService(opt && opt.value)} isClearable menuPortalTarget={document.body} />
                    </div>

                    <div className="filter-foot">
                        <span className="meta">
                            {activeCount > 0 ? (activeCount > 1 ? t('sales.filtersSelectedPlural', { count: activeCount }) : t('sales.filtersSelected', { count: activeCount })) : t('sales.noFiltersApplied')}
                        </span>
                        <div className="sp">
                            <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={handleReset}>{t('sales.reset')}</button>
                            <button type="submit" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isFiltering}>
                                {isFiltering ? t('sales.filtering') : t('sales.applyFilters')}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </>
    )
}

export default SalesFilter
